import { dateToDateOnlyApiFormat, parseDateOnly } from '@/helpers/dateHelper';
import { useGetEmployeeLeaveRequestPreviewQuery } from '@/services/gql/graphql.generated';
import { useMemo } from 'react';

export const useEmployeeLeaveRequestPreview = (employeeId: string, leaveTypeId: string, start: Date, end: Date) => {
  const [{ data, fetching }] = useGetEmployeeLeaveRequestPreviewQuery({
    variables: {
      employeeId,
      leaveTypeId,
      dateRange: { start: dateToDateOnlyApiFormat(start), end: dateToDateOnlyApiFormat(end) }
    },
    pause: !employeeId || !leaveTypeId || start > end,
    requestPolicy: 'network-only'
  });

  const preview = data?.employeeLeaveRequestPreview;
  const overlappingDates = useMemo(
    () => (preview?.overlappingDates ?? []).map(parseDateOnly),
    [preview?.overlappingDates]
  );

  return {
    hasPreview: !!preview,
    checks: preview?.checks ?? [],
    daysToTake: preview?.daysToTake ?? 0,
    fetching,
    exceeded: preview?.checks.some(check => check.exceeds) ?? false,
    overlappingDates,
    hasOverlap: overlappingDates.length > 0
  };
};
